<template>
  <FileUploadSlot @update:file="uploadFile">
    <template v-slot:activator="{ on }">
      <v-btn
        color="accent"
        v-on="on"
        block
        class="rounded-4"
        depressed
        large
        readonly
        :disabled="loading"
      >
        {{ loading ? '서류를 제출중입니다' : '증빙 서류 추가하기' }}
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="grey"
          size="21"
          width="2"
          class="ml-2"
        ></v-progress-circular>
      </v-btn>
    </template>
  </FileUploadSlot>
</template>

<script>
import RequestFileUploadMixin from './RequestFileUploadMixin.js'

export default {
  mixins: [RequestFileUploadMixin],
}
</script>

<style lang="scss" scoped>
::v-deep .v-expansion-panel-header .v-expansion-panel-header__icon {
  transform-origin: none;
  display: block !important;
}
</style>
